































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { IAction } from "../common/CommonTypes";
import ConfirmDialog from "../user-management/ConfirmDialog.vue";
import MasterListDialog from "./MasterListDialog.vue";
import { TYPE, ACTION, MASTER_DIALOG } from "./";
import {
  TreatmentMasterListsApi,
  PostTreatmentMasterListRequest,
  PutTreatmentMasterListRequest,
} from "../../../apis";
import { forEach } from "lodash";

@Component({
  components: {
    MoreVertBtn,
    ConfirmDialog,
    MasterListDialog,
  },
})
export default class MasterListTab extends Vue {
  selectedPermisstion = {} as any;
  errDialog = "";
  confirmContent = "";
  showConfirmDialog = false;
  treatmentTypeDialog = "";
  productItems = [];
  insectItems = [];
  packageItems = [];
  techniqueItems = [];
  setpointParametersItems = [];
  codeTreatment = [];
  isShowMasterListDialog = false;
  mode: ACTION = null;

  async mounted() {
    await this.initData();
  }

  get actions(): IAction[] {
    return [
      { titleName: this.$t("text.edit"), action: ACTION.EDIT },
      { titleName: this.$t("text.delete"), action: ACTION.DELETE },
      { titleName: this.$t("text.disable"), action: ACTION.DISABLE },
      { titleName: this.$t("text.enable"), action: ACTION.ENABLE },
    ];
  }

  get STATUS() {
    return [
      { value: "INACTIVE", text: this.$t("treatment.inactive") },
      { value: "ACTIVE", text: this.$t("treatment.active") },
    ];
  }

  get productHeaders() {
    return [
      {
        text: this.$t("text.productName"),
        value: "treatmentName",
        sortable: false,
        width: "70%",
      },
      { text: this.$t("text.status"), value: "status", sortable: false },
      { text: this.$t("text.action"), value: "action", sortable: false },
    ];
  }

  get insectHeaders() {
    return [
      {
        text: this.$t("text.insectName"),
        value: "treatmentName",
        sortable: false,
        width: "70%",
      },
      { text: this.$t("text.status"), value: "status", sortable: false },
      { text: this.$t("text.action"), value: "action", sortable: false },
    ];
  }

  get headerPackage() {
    return [
      {
        text: this.$t("text.package"),
        value: "treatmentName",
        sortable: false,
        width: "70%",
      },
      { text: this.$t("text.status"), value: "status", sortable: false },
      { text: this.$t("text.action"), value: "action", sortable: false },
    ];
  }

  get techniqueHeaders() {
    return [
      {
        text: this.$t("text.techniqueName"),
        value: "treatmentName",
        sortable: false,
        width: "70%",
      },
      { text: this.$t("text.status"), value: "status", sortable: false },
      { text: this.$t("text.action"), value: "action", sortable: false },
    ];
  }

  get setpointParametersHeaders() {
    return [
      {
        text: this.$t("text.setpointName"),
        value: "treatmentName",
        sortable: false,
        width: "70%",
      },
      { text: this.$t("text.status"), value: "status", sortable: false },
      { text: this.$t("text.action"), value: "action", sortable: false },
    ];
  }

  checkStatusAction(status: string) {
    if (status == "Inactive")
      return this.actions.filter((val) => val.action != ACTION.DISABLE);
    return this.actions.filter((val) => val.action != ACTION.ENABLE);
  }

  checkStatusActionWithoutDelete(item) {
    if (item.code.length > 0) {
      if (item.status == "Inactive")
        return this.actions.filter(
          (val) => val.action != ACTION.DELETE && val.action != ACTION.DISABLE
        );
      return this.actions.filter(
        (val) => val.action != ACTION.DELETE && val.action != ACTION.ENABLE
      );
    } else {
      if (item.status == "Inactive")
        return this.actions.filter((val) => val.action != ACTION.DISABLE);
      return this.actions.filter((val) => val.action != ACTION.ENABLE);
    }
  }

  async initData() {
    this.$util.showLoading();
    try {
      const res = await new TreatmentMasterListsApi().getTreatments();
      this.productItems = res.data.data.filter(
        (val) => val.treatmentType === TYPE.PRODUCT
      );
      this.insectItems = res.data.data.filter(
        (val) => val.treatmentType === TYPE.INSECT
      );
      this.packageItems = res.data.data.filter(
        (val) => val.treatmentType === TYPE.PACKAGE
      );
      this.techniqueItems = res.data.data.filter(
        (val) => val.treatmentType === TYPE.TECHNIQUE
      );
      this.setpointParametersItems = res.data.data.filter(
        (val) => val.treatmentType === TYPE.SETPOINT_PARAMETERS
      );
      this.codeTreatment = res.data.data.filter((val) => val.code.length > 0);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  readonly NEW = ACTION.NEW;
  readonly EDIT = ACTION.EDIT;

  readonly PRODUCT = MASTER_DIALOG.PRODUCT;
  readonly INSECT = MASTER_DIALOG.INSECT;
  readonly PACKAGE = MASTER_DIALOG.PACKAGE;
  readonly TECHNIQUE = MASTER_DIALOG.TECHNIQUE;
  readonly SETPOINT_PARAMETERS = MASTER_DIALOG.SETPOINT_PARAMETERS;

  getDialogShow(type: string) {
    if (type == TYPE.PRODUCT) {
      this.isShowMasterListDialog = true;
    }
    if (type == TYPE.INSECT) {
      this.isShowMasterListDialog = true;
    }
    if (type == TYPE.PACKAGE) {
      this.isShowMasterListDialog = true;
    }
    if (type == TYPE.TECHNIQUE) {
      this.isShowMasterListDialog = true;
    }
    if (type == TYPE.SETPOINT_PARAMETERS) {
      this.isShowMasterListDialog = true;
    }
  }

  async doDelete() {
    try {
      this.$util.showLoading();
      const res = await new TreatmentMasterListsApi().deleteTreatment({
        id: this.selectedPermisstion.id,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.initData();
    }
  }

  onCancelDialog() {
    this.errDialog = "";
  }

  onOkConfirmDialog() {
    if (this.selectedAction === ACTION.DELETE) {
      this.doDelete();
    }
    if (this.selectedAction === ACTION.ENABLE) {
      this.doUpdate();
    }
    if (this.selectedAction === ACTION.DISABLE) {
      this.doUpdate();
    }
  }

  onDeleteMaster() {
    this.showConfirmDialog = true;
    this.confirmContent = `${this.$t(
      "dialog.confirmMasterList.contentDelete"
    )} ${this.selectedPermisstion.treatmentName} ?`;
  }
  onDisableMaster() {
    this.showConfirmDialog = true;
    this.confirmContent = `${this.$t(
      "dialog.confirmMasterList.contentDisable"
    )} ${this.selectedPermisstion.treatmentName} ?`;
  }
  onEnableMaster() {
    this.showConfirmDialog = true;
    this.confirmContent = `${this.$t(
      "dialog.confirmMasterList.contentEnable"
    )} ${this.selectedPermisstion.treatmentName}?`;
  }

  selectedAction: ACTION;
  onSelectedPermission(item, action): void {
    this.selectedPermisstion = { ...item };
    this.selectedAction = action;
    switch (action) {
      case ACTION.EDIT: {
        this.initData();
        this.getDialogShow(this.selectedPermisstion.treatmentType);
        this.treatmentTypeDialog = this.selectedPermisstion.treatmentType;
        this.mode = ACTION.EDIT;
        break;
      }
      case ACTION.DELETE: {
        this.onDeleteMaster();
        break;
      }
      case ACTION.DISABLE: {
        this.onDisableMaster();
        break;
      }
      case ACTION.ENABLE: {
        this.onEnableMaster();
        break;
      }
      default: {
        break;
      }
    }
  }

  async doUpdate() {
    try {
      this.$util.showLoading();
      let statusSelect = this.selectedPermisstion.status;
      statusSelect = this.getChangeStatus(statusSelect);
      const body = {
        treatmentName: this.selectedPermisstion.treatmentName,
        status: statusSelect,
        treatmentType: this.selectedPermisstion.treatmentType,
      };
      const res = await new TreatmentMasterListsApi().updateTreatment({
        id: this.selectedPermisstion.id,
        putTreatmentMasterListRequest: body as PutTreatmentMasterListRequest,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.initData();
    }
  }

  getChangeStatus(status: string) {
    if (status == "Inactive") return (status = "Active");
    if (status == "Active") return (status = "Inactive");
  }

  onOpenDialog(dialogName: MASTER_DIALOG, seletedItem?: any) {
    switch (dialogName) {
      case MASTER_DIALOG.PRODUCT: {
        this.isShowMasterListDialog = true;
        this.mode = ACTION.NEW;
        this.treatmentTypeDialog = TYPE.PRODUCT;
        this.initData();
        break;
      }
      case MASTER_DIALOG.INSECT: {
        this.isShowMasterListDialog = true;
        this.mode = ACTION.NEW;
        this.treatmentTypeDialog = TYPE.INSECT;
        this.initData();
        break;
      }
      case MASTER_DIALOG.PACKAGE: {
        this.isShowMasterListDialog = true;
        this.mode = ACTION.NEW;
        this.treatmentTypeDialog = TYPE.PACKAGE;
        this.initData();
        break;
      }
      case MASTER_DIALOG.TECHNIQUE: {
        this.isShowMasterListDialog = true;
        this.mode = ACTION.NEW;
        this.treatmentTypeDialog = TYPE.TECHNIQUE;
        this.initData();
        break;
      }
      case MASTER_DIALOG.SETPOINT_PARAMETERS: {
        this.isShowMasterListDialog = true;
        this.mode = ACTION.NEW;
        this.treatmentTypeDialog = TYPE.SETPOINT_PARAMETERS;
        this.initData();
        break;
      }
      default: {
        break;
      }
    }
  }

  async onSaved(dialogName: MASTER_DIALOG, action: ACTION) {
    switch (dialogName) {
      case MASTER_DIALOG.PRODUCT: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      case MASTER_DIALOG.INSECT: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      case MASTER_DIALOG.PACKAGE: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      case MASTER_DIALOG.TECHNIQUE: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      case MASTER_DIALOG.SETPOINT_PARAMETERS: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      default: {
        break;
      }
    }
  }

  onCanceled(dialogName: MASTER_DIALOG, action: ACTION) {
    switch (dialogName) {
      case this.PRODUCT: {
        this.isShowMasterListDialog = false;
        this.initData();
        break;
      }
      case MASTER_DIALOG.INSECT: {
        this.isShowMasterListDialog = false;
        this.initData();
        break;
      }
      case MASTER_DIALOG.PACKAGE: {
        this.isShowMasterListDialog = false;
        this.initData();
        break;
      }
      case MASTER_DIALOG.TECHNIQUE: {
        this.isShowMasterListDialog = false;
        this.initData();
        break;
      }
      case MASTER_DIALOG.SETPOINT_PARAMETERS: {
        this.isShowMasterListDialog = false;
        this.initData();
        break;
      }
      default: {
        break;
      }
    }
  }

  async onCloseEdit(dialogName: MASTER_DIALOG, action: ACTION) {
    switch (dialogName) {
      case this.PRODUCT: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      case MASTER_DIALOG.INSECT: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      case MASTER_DIALOG.PACKAGE: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      case MASTER_DIALOG.TECHNIQUE: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      case MASTER_DIALOG.SETPOINT_PARAMETERS: {
        await this.initData();
        this.isShowMasterListDialog = false;
        break;
      }
      default: {
        break;
      }
    }
  }
}
